import script from "./WechatChatFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./WechatChatFooter.vue?vue&type=script&setup=true&lang=js"

import "./WechatChatFooter.vue?vue&type=style&index=0&id=07dd6b03&scoped=true&lang=scss"
import "./WechatChatFooter.vue?vue&type=style&index=1&id=07dd6b03&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07dd6b03"]])

export default __exports__